import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NuvexAccessLayout from "./NuvexAccessLayout";
import {
  FUNCTIONALITIES,
  NUVEX_ACCESS_BASE,
  nuvexAccessDefaultRoute,
} from "./config";

// Builds the nested route tree for /nuvex-access from the nav config so the
// sub-menu and the routes never drift apart. One child route per sub-item,
// plus index redirects (section -> first functionality, functionality -> its
// dashboard).
const children: RouteObject[] = [
  { index: true, element: <Navigate to={nuvexAccessDefaultRoute} replace /> },
];

for (const f of FUNCTIONALITIES) {
  children.push({
    path: f.slug,
    element: <Navigate to={`${NUVEX_ACCESS_BASE}/${f.slug}/${f.menu[0].id}`} replace />,
  });
  for (const item of f.menu) {
    children.push({ path: `${f.slug}/${item.id}`, element: item.element });
  }
}

export const nuvexAccessRoute: RouteObject = {
  path: NUVEX_ACCESS_BASE,
  element: <NuvexAccessLayout />,
  children,
};
